package com.tovtalk.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.tovtalk.ui.platform.TovTalkVideoPlayer
import com.tovtalk.ui.theme.TovTalkTheme

@Composable
actual fun UploadPreviewVideoPlayer(
    videoUrl: String?,
    modifier: Modifier,
    compactHeight: Dp,
    loop: Boolean,
    muted: Boolean,
    isPlaying: Boolean,
    fillContainer: Boolean,
    onTap: (() -> Unit)?
) {
    if (videoUrl == null) return

    val containerModifier = if (fillContainer) {
        modifier.fillMaxSize().background(TovTalkTheme.colors.surfaceOverlay)
    } else {
        modifier.height(compactHeight).fillMaxWidth().background(TovTalkTheme.colors.surfaceOverlay)
    }

    val tapModifier = if (onTap != null) {
        containerModifier.clickable { onTap() }
    } else {
        containerModifier
    }

    Box(modifier = tapModifier) {
        TovTalkVideoPlayer(
            videoUrl = videoUrl,
            thumbnailUrl = null,
            modifier = Modifier.fillMaxWidth(),
            isMuted = muted,
            isPlaying = isPlaying,
            fillContainer = fillContainer,
            onVideoEnded = if (loop) {
                { /* loop handled by caller */ }
            } else null
        )
    }
}
